import $ from 'jquery';
import Popper from 'popper.js';

const ClassName = {
  VISIBLE: 'dropdown--visible',
};

class Dropdown {
  constructor(element) {
    const dropdown = $(element).appendTo('body');
    const reference = $(
      `[data-dropdown-toggle="${dropdown.data('dropdown')}"]`
    );

    // Private
    this._active = false;
    this._dropdown = null;
    this._popper = null;

    // Protected
    this.html = $('html');
    this.reference = reference;
    this.dropdown = dropdown;
    this.options = {
      position: dropdown.data('dropdownPosition') || 'bottom-start',
      modifiers: {
        offset: {
          enabled: dropdown.data('dropdownOffset') || false,
          offset: `${dropdown.data('dropdownOffsetX')}, ${dropdown.data(
            'dropdownOffsetY'
          )}`,
        },
      },
    };

    this._setListeners();
  }

  _setListeners() {
    this.reference.on('click', event => this.toggle(event));
  }

  _getBodyEvent() {
    return `click.dropdown_${this.reference.data('dropdown-toggle')}`;
  }

  isActive() {
    return this.dropdown.hasClass(ClassName.VISIBLE);
  }

  show(event) {
    event.preventDefault();

    $(document).on(this._getBodyEvent(), event => {
      if (
        event.target === this.dropdown[0] ||
        $(this.dropdown[0]).has(event.target).length > 0
      )
        return;

      event.preventDefault();
      this.onBodyClick(event);
    });

    this.reference.attr('aria-expanded', true);

    this._popper = new Popper(this.reference, this.dropdown, {
      placement: this.options.position,
      modifiers: this.options.modifiers,
      removeOnDestroy: false,
    });

    this.dropdown.show(0, () => {
      this.dropdown.addClass(ClassName.VISIBLE);
    });
  }

  onBodyClick(event) {
    if (event.target !== this.reference[0]) {
      this.hide();
    }
  }

  hide(event = null) {
    if (event) {
      event.preventDefault();
    }

    $(document).off(this._getBodyEvent());
    $(this.dropdown).off(this._getBodyEvent());

    this.dropdown.removeClass(ClassName.VISIBLE);

    this.reference.attr('aria-expanded', false);

    setTimeout(() => {
      this.dropdown.hide();
      this._popper.destroy();
    }, 250);
  }

  toggle(event) {
    if (this.isActive()) {
      this.hide(event);
    } else {
      this.show(event);
    }
  }
}

const dropdown = selector => {
  $(selector).each((index, element) => {
    new Dropdown(element);
  });
};

export default dropdown;
